const visaRegex = new RegExp('^4[0-9]{0,15}$')
const mastercardRegex = new RegExp('^5$|^5[1-5][0-9]{0,14}$')
const amexRegex = new RegExp('^3$|^3[47][0-9]{0,13}$')
const dinersRegex = new RegExp(
  '^3$|^3[068]$|^3(?:0[0-5]|[68][0-9])[0-9]{0,11}$'
)
const discoverRegex = new RegExp(
  '^6$|^6[05]$|^601[1]?$|^65[0-9][0-9]?$|^6(?:011|5[0-9]{2})[0-9]{0,12}$'
)
const jcbRegex = new RegExp(
  '^2[1]?$|^21[3]?$|^1[8]?$|^18[0]?$|^(?:2131|1800)[0-9]{0,11}$|^3[5]?$|^35[0-9]{0,14}$'
)

export const getFormatedExpirationDate = (ed) => {
  const date = ed
  let month = ''
  let year = ''
  if (date.includes('/')) {
    ;[month, year] = date.split('/')
  } else if (date.length) {
    month = date.substr(0, 2)
    year = date.substr(2, 6)
  }
  while (month.length < 2) {
    month += '0'
  }
  if (year.length > 2) {
    year = year.substr(2, 4)
  }
  while (year.length < 2) {
    year += '0'
  }
  return `${month}/${year}`
}

export const getFormatedNumber = (rowNumber, placeHolder) => {
  const preview = true
  const maxLengt = 16
  const number = rowNumber
  let maxLength = preview ? 19 : maxLengt
  let nextNumber =
    typeof number === 'number'
      ? number.toString()
      : number.replace(/[A-Za-z]| /g, '')

  if (Number.isNaN(parseInt(nextNumber, 10)) && !preview) {
    nextNumber = '•'
  }

  if (maxLength > 16) {
    maxLength = nextNumber.length <= 16 ? 16 : maxLength
  }

  if (nextNumber.length > maxLength) {
    nextNumber = nextNumber.slice(0, maxLength)
  }

  if (nextNumber.length < maxLength) {
    nextNumber =
      nextNumber + placeHolder.replaceAll(' ', '').substr(nextNumber.length)
  }

  if (['amex', 'dinersclub'].includes('sss')) {
    const format = [0, 4, 10]
    const limit = [4, 6, 5]
    nextNumber = `${nextNumber.substr(format[0], limit[0])} ${nextNumber.substr(
      format[1],
      limit[1]
    )} ${nextNumber.substr(format[2], limit[2])}`
  } else if (nextNumber.length > 16) {
    const format = [0, 4, 8, 12]
    const limit = [4, 7]
    nextNumber = `${nextNumber.substr(format[0], limit[0])} ${nextNumber.substr(
      format[1],
      limit[0]
    )}
    ${nextNumber.substr(format[2], limit[0])} ${nextNumber.substr(
      format[3],
      limit[1]
    )}`
  } else {
    for (let i = 1; i < maxLength / 4; i += 1) {
      const ie = i * 4
      const spaceIndex = ie + (i - 1)
      nextNumber = `${nextNumber.slice(0, spaceIndex)} ${nextNumber.slice(
        spaceIndex
      )}`
    }
  }
  return nextNumber
}

export const getFormatedCVV = (cvv) => new Array(cvv.length).fill('*').join('')

export const getCardType = (cardNumber) => {
  const result = {
    cardType: 'Uknown'
  }

  if (!cardNumber) return result

  if (cardNumber.match(visaRegex)) {
    result.cardType = 'VISA'
  }
  if (cardNumber.match(mastercardRegex)) {
    result.cardType = 'MASTERCARD'
  }
  if (cardNumber.match(amexRegex)) {
    result.cardType = 'OTHER'
  }
  if (cardNumber.match(dinersRegex)) {
    result.cardType = 'OTHER'
  }
  if (cardNumber.match(discoverRegex)) {
    result.cardType = 'OTHER'
  }
  if (cardNumber.match(jcbRegex)) {
    result.cardType = 'OTHER'
  }

  return result
}
